module.exports = __webpack_public_path__ + "static/media/Surreal-estate.9d9cd767.png";